import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GoGoLiveParentGuideLocaleListQueryVariables = Types.Exact<{
  goGoLiveParentGuideId: Types.Scalars['Int']['input'];
}>;


export type GoGoLiveParentGuideLocaleListQuery = { __typename?: 'Query', goGoLiveParentGuideLocaleList: Array<{ __typename?: 'GoGoLiveParentGuideLocaleInfo', goGoLiveParentGuideLocaleId: number, goGoLiveParentGuideId: number, market: string, introduction: string, learningGoals: string, showAndTell: string }> };


export const GoGoLiveParentGuideLocaleListDocument = gql`
    query GoGoLiveParentGuideLocaleList($goGoLiveParentGuideId: Int!) {
  goGoLiveParentGuideLocaleList(goGoLiveParentGuideId: $goGoLiveParentGuideId) {
    goGoLiveParentGuideLocaleId
    goGoLiveParentGuideId
    market
    introduction
    learningGoals
    showAndTell
  }
}
    `;

/**
 * __useGoGoLiveParentGuideLocaleListQuery__
 *
 * To run a query within a React component, call `useGoGoLiveParentGuideLocaleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoGoLiveParentGuideLocaleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoGoLiveParentGuideLocaleListQuery({
 *   variables: {
 *      goGoLiveParentGuideId: // value for 'goGoLiveParentGuideId'
 *   },
 * });
 */
export function useGoGoLiveParentGuideLocaleListQuery(baseOptions: Apollo.QueryHookOptions<GoGoLiveParentGuideLocaleListQuery, GoGoLiveParentGuideLocaleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoGoLiveParentGuideLocaleListQuery, GoGoLiveParentGuideLocaleListQueryVariables>(GoGoLiveParentGuideLocaleListDocument, options);
      }
export function useGoGoLiveParentGuideLocaleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoGoLiveParentGuideLocaleListQuery, GoGoLiveParentGuideLocaleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoGoLiveParentGuideLocaleListQuery, GoGoLiveParentGuideLocaleListQueryVariables>(GoGoLiveParentGuideLocaleListDocument, options);
        }
export type GoGoLiveParentGuideLocaleListQueryHookResult = ReturnType<typeof useGoGoLiveParentGuideLocaleListQuery>;
export type GoGoLiveParentGuideLocaleListLazyQueryHookResult = ReturnType<typeof useGoGoLiveParentGuideLocaleListLazyQuery>;
export type GoGoLiveParentGuideLocaleListQueryResult = Apollo.QueryResult<GoGoLiveParentGuideLocaleListQuery, GoGoLiveParentGuideLocaleListQueryVariables>;